/* Slider delle collezioni sulla pagina "tutte le fragranze".
   Stesso schema di MONOM: le boccette scorrono in orizzontale, l'ultima resta tagliata
   a destra per far capire che si scorre, e sotto c'e' una riga con le due frecce agli
   estremi e un indicatore che segue lo scorrimento. Nessuna libreria. */
(function () {
  'use strict';
  if (!document.body || document.body.id !== 'contatti') return;

  function bottone(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'salum-slider__freccia salum-slider__freccia--' + dir;
    b.setAttribute('aria-label', dir === 'prec' ? 'Fragranze precedenti' : 'Fragranze successive');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' +
      (dir === 'prec' ? 'M19 12H5M11 6l-6 6 6 6' : 'M5 12h14M13 6l6 6-6 6') + '"/></svg>';
    return b;
  }

  function attiva(griglia) {
    if (griglia.dataset.salumSlider) return;
    griglia.dataset.salumSlider = '1';

    var box = document.createElement('div');
    box.className = 'salum-slider';
    griglia.parentNode.insertBefore(box, griglia);
    box.appendChild(griglia);
    griglia.classList.add('salum-slider__pista');

    var comandi = document.createElement('div');
    comandi.className = 'salum-slider__comandi';
    var prec = bottone('prec');
    var succ = bottone('succ');
    var riga = document.createElement('div');
    riga.className = 'salum-slider__riga';
    var cursore = document.createElement('span');
    cursore.className = 'salum-slider__cursore';
    riga.appendChild(cursore);
    comandi.appendChild(prec);
    comandi.appendChild(riga);
    comandi.appendChild(succ);
    box.appendChild(comandi);

    function passo() {
      var c = griglia.querySelector('.featured-product--grid-item');
      if (!c) return griglia.clientWidth;
      var gap = parseFloat(getComputedStyle(griglia).columnGap) || 0;
      return c.getBoundingClientRect().width + gap;
    }

    function aggiorna() {
      var totale = griglia.scrollWidth;
      var visibile = griglia.clientWidth;
      var margine = totale - visibile;
      var scorre = margine > 4;
      box.classList.toggle('salum-slider--scorre', scorre);
      if (!scorre) return;
      var quota = visibile / totale;
      var larghezzaRiga = riga.clientWidth;
      var lCursore = Math.max(40, larghezzaRiga * quota);
      var avanzamento = margine > 0 ? griglia.scrollLeft / margine : 0;
      cursore.style.width = lCursore + 'px';
      cursore.style.transform = 'translateX(' + ((larghezzaRiga - lCursore) * avanzamento) + 'px)';
      prec.disabled = griglia.scrollLeft <= 2;
      succ.disabled = griglia.scrollLeft >= margine - 2;
    }

    prec.addEventListener('click', function () { griglia.scrollBy({ left: -passo(), behavior: 'smooth' }); });
    succ.addEventListener('click', function () { griglia.scrollBy({ left: passo(), behavior: 'smooth' }); });
    griglia.addEventListener('scroll', aggiorna, { passive: true });
    window.addEventListener('resize', aggiorna);
    if (window.ResizeObserver) new ResizeObserver(aggiorna).observe(griglia);
    aggiorna();
  }

  function avvia() {
    document.querySelectorAll('[id*="featured_collection"] .product-grid--wrapper').forEach(attiva);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
